export class SelectItem{
    id: number;
    value: number;
    name: string;
    title: string;
    text: string;
}
